<template>
  <div>
    <v-select
      ref="select"
      v-bind="$attrs"
      :items="items"
      :value="value"
      :menu-props="{ closeOnContentClick: true }"
      @change="val => $emit('change', val)"
      @input="val => $emit('input', val)"
    >
      <template #prepend-item>
        <v-list-item @click="dialog.show = true">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ createOptionText }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mb-2" />
      </template>

      <template #item="{ item, attrs, on }">
        <v-list-item
          v-bind="attrs"
          v-on="on"
        >
          <v-list-item-icon v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ itemText(item) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-select>

    <category-edit-or-create-dialog
      ref="dialog"
      v-model="dialog.show"
      mode="create"
      :title="dialogTitle"
      :faq-id="faqId"
      :category-id="categoryId"
      :is-subcategory="isSubcategory"
      :preserve-state="true"
      @create-success="isSubcategory ? $emit('subcategory-created') : $emit('category-created')"
    />
  </div>
</template>

<script>
import i18n from '@/plugins/vue-i18n';
import get from 'lodash/get';
import CategoryEditOrCreateDialog from '@/components/faq/CategoryEditOrCreateDialog';

export default {
  components: {
    CategoryEditOrCreateDialog
  },

  props: {
    faqId: {
      type: Number,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    value: {
      type: [String, Object, Number],
      required: false,
      default: null
    },
    createOptionText: {
      type: String,
      required: false,
      default: i18n.t('Create new')
    },
    dialogTitle: {
      type: String,
      required: true,
    },
    categoryId: {
      type: Number,
      required: false,
      default: null
    },
    isSubcategory: {
      type: Boolean
    }
  },

  data() {
    return {
      dialog: {
        show: false,
      }
    }
  },

  methods: {
    blur() {
      this.$refs.select.blur();
    },

    itemText(item) {
      return get(item, this.$attrs['item-text']);
    }
  }
}
</script>